import { LabelSecondary } from '@components/label';

import { ControllerMultiTextArea } from './controller-multi-text-area';
import { InviteGuestMultipleInviteProps } from './invite-guest.type';
import { MultiOfferHeader } from './multi-offer-header';

export const MultiInviteGuest = ({
  title,
  instructionsTitle,
  instructionsDescription,
  textareaPlaceholder,
  offer,
  roleName,
}: InviteGuestMultipleInviteProps) => {
  return (
    <div className='flex flex-col gap-4 px-4 pb-6 sm:px-20 sm:pb-12'>
      <LabelSecondary>{title}</LabelSecondary>
      <MultiOfferHeader
        instructionsDescription={instructionsDescription}
        instructionsTitle={instructionsTitle}
        formName='multiInviteText'
      />
      <ControllerMultiTextArea
        textareaPlaceholder={textareaPlaceholder}
        formName='multiInviteText'
        offer={offer}
        roleName={roleName}
      />
    </div>
  );
};
